export default __webpack_public_path__ + "static/media/search.b357b3a3.svg";